import CalculatedAlerts from './CalculatedAlerts';
import DTCAlerts from './DTCAlerts';
import DTCAlertsHistory from './DTCAlertsHistory';
import SaleYearMakeModel from './SaleYearMakeModel';
import OperationStateChangeStatus from './OperationStateChangeStatus';
import LocatorVehicle from './LocatorVehicle';
import LocatorPaired from './LocatorPaired';
import BillAddendumCharges from './BillAddendumCharges';
import BillAddendumCredits from './BillAddendumCredits';
import BillTotalDue from './BillTotalDue';
import BillTotalPaid from './BillTotalPaid';
import BillPaymentStatus from './BillPaymentStatus';
import BillTotalWithAddendaCharges from './BillTotalWithAddendaCharges';
import SaleLocatorType from './SaleLocatorType';
import VehicleLocatorIcon from './VehicleLocatorIcon';
import BillLocationAddress from './BillLocationAddress';
import CalculatedContractState from './CalculatedContractState';
import VehicleTransferredOn from './VehicleTransferredOn';
import VehicleCreatedOn from './VehicleCreatedOn';
import VehiclePreviousLocation from './VehiclePreviousLocation';
import LocationGracePeriod from './LocationGracePeriod';
import LocationGraceEndDate from './LocationGraceEndDate';
import LocationSellThroughRate from './LocationSellThroughRate';
import LocationSevenDayPerformance from './LocationSevenDayPerformance';
import LocationThirtyDayPerformance from './LocationThirtyDayPerformance';
import RecovrProductsSold from './RecovrProductsSold';
import SaleTagIds from './SaleTagIds';
import SaleVoidedBy from './SaleVoidedBy';
import DeviceLocation from './DeviceLocation';
import BillLocationIntercomId from './BillLocationIntercomId';
const deviceTypes = ['vehicle', 'locator'];
export default {
  install(molten) {
    molten.addPlugin('Attribute', CalculatedAlerts);
    molten.addPlugin('Attribute', DTCAlerts);
    molten.addPlugin('Attribute', DTCAlertsHistory);
    molten.addPlugin('Attribute', SaleYearMakeModel);
    molten.addPlugin('Attribute', OperationStateChangeStatus);
    molten.addPlugin('Attribute', LocatorVehicle);
    molten.addPlugin('Attribute', LocatorPaired);
    molten.addPlugin('Attribute', BillAddendumCharges);
    molten.addPlugin('Attribute', BillAddendumCredits);
    molten.addPlugin('Attribute', BillTotalDue);
    molten.addPlugin('Attribute', BillTotalPaid);
    molten.addPlugin('Attribute', BillPaymentStatus);
    molten.addPlugin('Attribute', BillTotalWithAddendaCharges);
    molten.addPlugin('Attribute', BillLocationAddress);
    molten.addPlugin('Attribute', SaleLocatorType);
    molten.addPlugin('Attribute', CalculatedContractState);
    molten.addPlugin('Attribute', VehicleTransferredOn);
    molten.addPlugin('Attribute', VehicleCreatedOn);
    molten.addPlugin('Attribute', VehiclePreviousLocation);
    molten.addPlugin('Attribute', LocationGracePeriod);
    molten.addPlugin('Attribute', LocationGraceEndDate);
    molten.addPlugin('Attribute', LocationSellThroughRate);
    molten.addPlugin('Attribute', LocationSevenDayPerformance);
    molten.addPlugin('Attribute', LocationThirtyDayPerformance);
    molten.addPlugin('Attribute', RecovrProductsSold);
    molten.addPlugin('Attribute', SaleTagIds);
    molten.addPlugin('Attribute', SaleVoidedBy);
    molten.addPlugin('Attribute', BillLocationIntercomId);
    deviceTypes.forEach(deviceType => {
      molten.addPlugin('Attribute', DeviceLocation(deviceType));
      molten.addPlugin('Attribute', VehicleLocatorIcon(deviceType));
    });
  }
};